/** Audio paths */
export const AUDIO_PATHS = {
  employeeYearInReviewBg: 'audio/employee-year-in-review-bg.mp3',
} as const;

export type AudioPath = (typeof AUDIO_PATHS)[keyof typeof AUDIO_PATHS];

/** Audio volume settings (0.0 to 1.0) */
export const AUDIO_VOLUME = {
  backgroundMusic: 1,
} as const;

/** Audio fade-out duration in frames (~5s at 30fps) */
export const AUDIO_FADE_OUT_DURATION = 150;
